export function swipeActions() {
  // Seleccionar todos los elementos de la lista
  const listItems = document.querySelectorAll('.list-item');

  // Variables para el tracking del swipe
  let startX, moveX, currentSwipedItem = null;
  const swipeThreshold = 100; // Cantidad mínima de píxeles para considerar un swipe

  // Función para resetear todos los elementos que estén abiertos
  function resetAllItems() {
    document.querySelectorAll('.list-item.swiped').forEach(item => {
      item.classList.remove('swiped');
      const itemLink = item.querySelector('.list-item__link');
      if (itemLink) {
        itemLink.style.transform = 'translateX(0)';
        setTimeout(() => {
          itemLink.style.pointerEvents = 'auto'; // Reactivar el enlace con retraso
        }, 300); 
      }
    });
    currentSwipedItem = null;
  }

  // Preparar cada elemento de la lista
  listItems.forEach(item => {
    const itemLink = item.querySelector('.list-item__link');
    const actionButtons = item.querySelector('.item-actions');
    
    if (itemLink && actionButtons) {
      // Calcular el ancho de los botones de acción
      const actionsWidth = actionButtons.offsetWidth || actionButtons.getBoundingClientRect().width;
      
      // Escuchar eventos de clic en el enlace
      itemLink.addEventListener('click', function(e) {
        if (item.classList.contains('swiped')) {
          e.preventDefault();
          e.stopPropagation();
          resetAllItems();
        }
      }, true);
      
      // Inicializar eventos touch
      initTouchEvents(item, itemLink, actionsWidth);
    }
  });

  // Función para inicializar eventos touch
  function initTouchEvents(item, itemLink, actionsWidth) {
    itemLink.addEventListener('touchstart', (e) => {
      if (e.target.closest('.btn-circle-icon')) return;
      
      startX = e.touches[0].clientX;
      moveX = startX;

      if (currentSwipedItem && currentSwipedItem !== item) {
        resetAllItems();
      }
    });

    itemLink.addEventListener('touchmove', (e) => {
      if (!startX || e.target.closest('.btn-circle-icon')) return;
      
      moveX = e.touches[0].clientX;
      const diff = moveX - startX;
      
      // Limitar el movimiento al ancho de los botones
      if (diff < 0) {
        const translateX = Math.max(diff, -actionsWidth);
        itemLink.style.transform = `translateX(${translateX}px)`;
        
        if (Math.abs(diff) > 10) e.preventDefault();
      }
    });

    itemLink.addEventListener('touchend', (e) => {
      if (!startX || e.target.closest('.btn-circle-icon')) return;
      
      const diff = moveX - startX;
      
      if (diff < -swipeThreshold) {
        // Si el swipe supera el umbral, abrir completamente
        itemLink.style.transform = `translateX(-${actionsWidth}px)`;
        item.classList.add('swiped');
        currentSwipedItem = item;
        itemLink.style.pointerEvents = 'none';
      } else {
        // Si no, volver a la posición inicial
        itemLink.style.transform = 'translateX(0)';
        item.classList.remove('swiped');
        
        setTimeout(() => {
          itemLink.style.pointerEvents = 'auto';
        }, 300);
      }
      
      startX = null;
    });
  }

  // Cerrar swipe al hacer clic fuera de los botones
  document.addEventListener('click', (e) => {
    if (document.querySelector('.list-item.swiped')) {
      if (!e.target.closest('.btn-circle-icon')) {
        resetAllItems();
      }
    }
  });
}